/**
 * Settings workspace navigation.
 * Channels is a top-level workspace, not a Settings section.
 */
import type { LucideIcon } from "lucide-react";
import { Gauge, Settings2, Shield, Users } from "lucide-react";
import type { OrganizationMemberRoleName } from "@multi-chat/shared";

export type SettingsNavId = "general" | "usage" | "team" | "security-data";

export type SettingsNavItem = {
  readonly id: SettingsNavId;
  readonly to: string;
  readonly labelKey: string;
  readonly shortLabelKey: string;
  readonly descriptionKey: string;
  readonly icon: LucideIcon;
  readonly testId: string;
  readonly ownerAdminOnly?: boolean;
};

export const SETTINGS_NAV_ITEMS: readonly SettingsNavItem[] = [
  {
    id: "general",
    to: "/settings/general",
    labelKey: "settings.nav.general",
    shortLabelKey: "settings.nav.generalShort",
    descriptionKey: "settings.nav.generalDescription",
    icon: Settings2,
    testId: "settings-nav-general",
  },
  {
    id: "usage",
    to: "/settings/usage",
    labelKey: "settings.nav.usage",
    shortLabelKey: "settings.nav.usageShort",
    descriptionKey: "settings.nav.usageDescription",
    icon: Gauge,
    testId: "settings-nav-usage",
    ownerAdminOnly: true,
  },
  {
    id: "team",
    to: "/settings/team",
    labelKey: "settings.nav.team",
    shortLabelKey: "settings.nav.teamShort",
    descriptionKey: "settings.nav.teamDescription",
    icon: Users,
    testId: "settings-nav-team",
  },
  {
    id: "security-data",
    to: "/settings/security-data",
    labelKey: "settings.nav.securityData",
    shortLabelKey: "settings.nav.securityDataShort",
    descriptionKey: "settings.nav.securityDataDescription",
    icon: Shield,
    testId: "settings-nav-security-data",
  },
];

export function settingsNavItemsForRole(
  role: OrganizationMemberRoleName,
): readonly SettingsNavItem[] {
  const canViewPlan = role === "OWNER" || role === "ADMIN";
  return SETTINGS_NAV_ITEMS.filter((item) => !item.ownerAdminOnly || canViewPlan);
}
